import { createClient } from 'contentful';

// Get the space ID and access token from environment variables or use fallbacks
const spaceId = process.env.REACT_APP_CONTENTFUL_SPACE_ID;
const accessToken = process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN;

// Create a Contentful client
const client = createClient({
  space: spaceId,
  accessToken: accessToken
});

// Get all blog posts
export const getBlogPosts = async () => {
  try {
    const entries = await client.getEntries({
      content_type: 'toolaBlog'
    });
    
    return entries.items;
  } catch (error) {
    return [];
  }
};

// Get a single blog post by ID or slug
export const getBlogPostBySlug = async (idOrSlug) => {
  try {
      const entries = await client.getEntries({
        content_type: 'toolaBlog',
        'sys.id': idOrSlug,
      });
      
      if (entries.items.length > 0) {
        return entries.items[0];
      }
      
      return null;
  } catch (error) {
    return null;
  }
}; 